// extracted by mini-css-extract-plugin
module.exports = {"announcement":"Announcement_announcement__3WsgI","title":"Announcement_title__1Tbka","description":"Announcement_description__1F5ta"};